import React from 'react'
import classNames from 'classnames'
import {useScreenType} from '@/hooks'
import {Icon} from '@/components'

import styles from './OnboardingAlert.scss'

export interface OnboardingAlertProps {
    visible: boolean
    text?: string
    title?: string
    content?: React.ReactNode
    className?: string
    variant?: 'info' | 'warning' | 'success'
    onBackdropClick?: () => void
}

export const OnboardingAlert: React.FC<OnboardingAlertProps> = ({
    visible,
    text,
    title,
    content,
    className,
    variant = 'info',
    onBackdropClick
}) => {
    const {isMobile, isTablet, isLaptop} = useScreenType()
    const isMobileView = isMobile || isTablet

    const getIconByVariant = () => {
        switch (variant) {
            case 'warning':
                return <Icon type='info' />
            case 'success':
                return <Icon type='info' />
            case 'info':
            default:
                return <Icon type='info' />
        }
    }

    return (
        <>
            {isMobileView && visible && (
                <div className={styles.mobileBackdrop} onClick={onBackdropClick} />
            )}
            
            <div
                className={classNames(
                    styles.onboardingAlert,
                    {
                        [styles.onboardingAlertInfo]: variant === 'info',
                        [styles.onboardingAlertWarning]: variant === 'warning',
                        [styles.onboardingAlertSuccess]: variant === 'success',
                        [styles.onboardingAlertVisible]: visible,
                        [styles.onboardingAlertMobile]: isMobileView,
                        [styles.onboardingAlertLaptop]: isLaptop
                    },
                    className
                )}
            >
                {title || content ? (
                    <>
                        <div className={styles.alertHeader}>
                            <div className={styles.alertIcon}>{getIconByVariant()}</div>
                            <div>
                                {title && <div className={styles.alertTitle}>{title}</div>}
                                <div className={styles.alertContent}>{content || text}</div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.alertIcon}>{getIconByVariant()}</div>
                        <div className={styles.alertText}>{text}</div>
                    </>
                )}
            </div>
        </>
    )
}
